export default "/assets/images/flexed-biceps.b21441184448e519.png";